export default __webpack_public_path__ + "static/media/4.0a15a312.jpg";